import React, { useState } from "react";


import Header from "./header/Header";
import Banner from "./banner/Banner";
import Whyvendora from "./why-vendora/Whyvendora";
import Counter from "./counter/Counter";
import Features from "./features/Features";
import Benefits from "./benefits/Benefits";
import Industries from "./industries/Industries";
import Testimonial from "./testimonial-form/Testimonial";
import Client from "./client/Client";
import Footer from "./footer/Footer";
import Management from "./management/Management";
import Core from "./core/Core";

const Home = () => {
    const [formSubmitted, setFormSubmitted] = useState(false);

    // Function to handle form submission
    const handleFormSubmit = () => {
      // Your form submission logic here...
      // If the form is successfully submitted, setFormSubmitted(true);
      // If there's an error or validation fails, do not setFormSubmitted(true);
      // You can use setFormSubmitted(true); where you handle the form submission.
    };
  
    return(
        <div className="home">
 <Header />
      <Banner />
      <Management />
      <Whyvendora />
      <Core />
      <Counter />
      <Features />
      <Benefits />
      <Industries />
      {formSubmitted ? (
        // Render the thank-you message or component
        <div className="thank-you-message">
          <h2>Thank you for submitting the form!</h2>
          {/* You can add additional content or links to the thank-you page */}
        </div>
      ) : (
        // Render the form component
        <Testimonial onFormSubmit={handleFormSubmit} />
        
      )}
      <Client />
      <Footer />
        </div>
    )
}

export default Home;